<div
  class="card kpi {{ cssClass }}"
  appTootltip="Voir l'historique"
  (click)="showHistory()"
>
  <div class="card-body d-flex flex-row">
    <div class="kpi-content">
      <p class="kpi-value">{{ value !== undefined ? value : "-" }}</p>
      <p class="kpi-title">{{ title }}</p>
      <p class="kpi-details">{{ details }}</p>
    </div>
    <div class="kpi-icon">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
  </div>
</div>
